'use client';
import { sendGTMEvent } from '../sendGTMEvent';
import { productListItemToGAItem } from '../productMappers/productListItemToGAItem';
import { getSelectItemData } from '../itemSelectionUtils';
import type { CommerceModel } from 'api-types';

/**
 * Tracks when a user adds payment information during checkout.
 * 
 * This function sends an add_payment_info event with the cart contents
 * and payment method information.
 * 
 * @param products - Array of line items in the cart
 * @param value - Total value of the cart
 * @param paymentType - Type of payment method (e.g., 'credit_card', 'paypal')
 * @param currency - Currency code (optional, defaults to product currency or DKK)
 */
export const trackAddPaymentInfo = (
  basket: CommerceModel.Basket,
  value: number,
  paymentType: string,
) => {
  // Determine currency from parameter, first product, or default to DKK
  const eventCurrency = basket.currency ?? '';

  // Map products to GA4 format
  const items = basket.lines?.map((product) => {
    const selectItemData = getSelectItemData(product.productId, product.productId);

    return productListItemToGAItem(product, {
      listId: selectItemData?.item_list_id,
      listName: selectItemData?.item_list_name,
      index: selectItemData?.index,
    });
  });

  sendGTMEvent({
    event: 'add_payment_info',
    ecommerce: {
      payment_type: paymentType,
      currency: eventCurrency,
      value,
      items: items || [],
    },
  });
};
